import React, { ReactNode } from 'react'
import { Modal } from '../Modal'
import { ModalHeader } from '../Modal/ModalHeader'
import { Image } from '../Image/Image'

export const ImagePreviewModal = ({
  showPreviewModal,
  url,
  onClose,
  text,
}: {
  showPreviewModal: boolean
  url: string
  onClose: () => void
  text: string
}): ReactNode => {
  return (
    <Modal show={showPreviewModal} size="sm">
      {{
        header: <ModalHeader onClose={onClose}>{text}</ModalHeader>,
        body: (
          <div className="flex justify-center px-6 pb-6 md:pb-8">
            <Image url={url} alt="Preview" className="rounded-md" />
          </div>
        ),
      }}
    </Modal>
  )
}
